// File: src/components/chat/MessageBubble/MessageBubble.tsx
// Purpose: Chat-related UI component

import React from "react";
import styled from "styled-components";
import {Typography} from "../../general/Typography";

interface MessageBubbleProps {
  children: React.ReactNode;
  isUser?: boolean;
}

const Bubble = styled.div<{ isUser: boolean }>`
  max-width: 75%;
  padding: ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.radii.md};
  background-color: ${({ theme, isUser }) =>
    isUser ? theme.colors.primary : theme.colors.surface};
  color: ${({ theme, isUser }) => (isUser ? theme.colors.buttonText : theme.colors.textPrimary)};
  align-self: ${({ isUser }) => (isUser ? "flex-end" : "flex-start")};
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Timestamp = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-top: 4px;
  align-self: flex-end;
`;

export const MessageBubble: React.FC<MessageBubbleProps> = ({ children, isUser = false }) => {
  return (
    <Bubble isUser={isUser}>
      {children}
    </Bubble>
  );
};